import Vue from 'vue';
import Element from 'element-ui';
import App from '@/App';
import i18n from '@/i18n';
import router from '@/router';
import store from '@/store';
import '@/icons';
import '@/element-ui/theme/index.css';
import '@/assets/scss/aui.scss';
import http from '@/utils/request';
import renRadioGroup from '@/components/ren-radio-group';
import renSelect from '@/components/ren-select';
import renDeptTree from '@/components/ren-dept-tree';
import renRegionTree from '@/components/ren-region-tree';
import {
  hasPermission,
  getDictLabel
} from '@/utils';
import cloneDeep from 'lodash/cloneDeep';
import Table from '@/components/table/index';
//筛选条件组件
import SearchCondition from '@/components/SearchCondition/index.vue';
import Pagination from '@/components/Pagination';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';

//富文本
import VueQuillEditor from 'vue-quill-editor';
// require styles 引入样式
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import {
  getDictDataList
} from '@/utils';

import locale from 'element-ui/lib/locale/lang/en'

Vue.use(VueQuillEditor);

Vue.config.productionTip = false;

// Vue.config.lang = 'en'
// Vue.locale('en', locale)

// Vue.use(Element, {
//   size: 'default',
//   i18n: (key, value) => i18n.t(key, value),
// });

Vue.use(Element, {
  locale
})

// Vue.config.lang = 'en'
// Vue.locale('en', locale)

Vue.use(renRadioGroup);
Vue.use(renSelect);
Vue.use(renDeptTree);
Vue.use(renRegionTree);
Vue.component('Table', Table);
Vue.component('SearchCondition', SearchCondition);
Vue.component('Pagination', Pagination);
Vue.component('Treeselect', Treeselect);

// 挂载全局
Vue.prototype.$http = http;
Vue.prototype.$hasPermission = hasPermission;
Vue.prototype.$getDictLabel = getDictLabel;
Vue.prototype.$getDictDataList = getDictDataList;

// 保存整站vuex本地储存初始状态
window.SITE_CONFIG['storeState'] = cloneDeep(store.state);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');